import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import { FaSave } from "react-icons/fa"
import { MdCancel } from "react-icons/md"
import Modules from "./Modules"
import { Switch } from "antd"

const RolesModal = ({ open, close, onSubmit, formData, setFormData, mode }) => {
  const [Permissions, setPermissions] = useState([])
  const [error, setError] = useState("")

  const isView = mode === "view"

  const handleToggle = (moduleId, field) => {
    const updated = Permissions.map(item => {
      if (item.id === moduleId) {
        return { ...item, [field]: item[field] === 1 ? 0 : 1 }
      }
      return item
    })
    setPermissions(updated)
  }

  useEffect(() => {
    if (formData?.id) {
      const permission = formData?.permissions
        ? JSON.parse(formData?.permissions)
        : []

      const Permissions = Modules.map((per, index) => {
        const perm = permission[index]

        return {
          ...per,
          viewGlobal: Number(perm?.viewGlobal || 0),
          view: Number(perm?.view || 0),
          add: Number(perm?.add || 0),
          edit: Number(perm?.edit || 0),
          delete: Number(perm?.delete || 0),
        }
      })

      setPermissions(Permissions)
    } else {
      setPermissions(Modules)
    }
  }, [formData])

  const handleSubmit = async () => {
    if (!formData?.roleName) {
      setError("Role Name is Required")
      return
    }

    const updatedFormData = {
      ...formData,
      permissions: JSON.stringify(Permissions),
    }
    setError("")
    onSubmit(updatedFormData)
  }

  return (
    <Modal isOpen={open} size="xl" centered>
      <ModalHeader
        toggle={() => {
          close(), setError("")
        }}
      >
        {isView ? "View" : formData?.id ? "Edit" : "Add"} Role
      </ModalHeader>
      <ModalBody>
        <div className="">
          <label>
            Role Name <span className="text-danger">*</span>
          </label>
          <input
            className="form-control"
            disabled={isView}
            value={formData?.roleName}
            onChange={e =>
              setFormData(prev => ({ ...prev, roleName: e.target.value }))
            }
          ></input>
          {error && <span className="text-danger">{error}</span>}
        </div>
        <Table
          className="table border-dark m-0 text-center mt-4  bg-light"
          striped
          bordered
        >
          <thead className="table-dark">
            <tr>
              <th className="text-start">Module</th>
              <th>View Global</th>
              <th>View</th>
              <th>Add</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {Permissions?.length > 0 &&
              Permissions.map(item => (
                <tr key={item.id} className="py-2">
                  <td
                    className={`text-start ${
                      !item.parentId ? "fw-bold" : "ps-5"
                    }`}
                  >
                    {item.module}
                  </td>

                  {/* View Global Switch */}
                  <td>
                    <Switch
                      checked={item.viewGlobal === 1}
                      onChange={() => handleToggle(item.id, "viewGlobal")}
                      disabled={isView}
                    />
                  </td>

                  {/* View Switch */}
                  <td>
                    <Switch
                      checked={item.view === 1}
                      onChange={() => handleToggle(item.id, "view")}
                      disabled={isView}
                    />
                  </td>

                  {/* Add Switch */}
                  <td>
                    {item.isAdd ? (
                      <Switch
                        checked={item.add === 1}
                        onChange={() => handleToggle(item.id, "add")}
                        disabled={isView}
                      />
                    ) : (
                      "--"
                    )}
                  </td>

                  {/* Edit Switch */}
                  <td>
                    {item.isEdit ? (
                      <Switch
                        checked={item.edit === 1}
                        onChange={() => handleToggle(item.id, "edit")}
                        disabled={isView}
                      />
                    ) : (
                      "--"
                    )}
                  </td>

                  {/* Delete Switch */}
                  <td>
                    {item.isDelete ? (
                      <Switch
                        checked={item.delete === 1}
                        onChange={() => handleToggle(item.id, "delete")}
                        disabled={isView}
                      />
                    ) : (
                      "--"
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        {!isView && (
          <Button className="btn-blue" onClick={() => handleSubmit()}>
            <FaSave /> Save
          </Button>
        )}
        <Button
          className="btn-secondary"
          onClick={() => {
            close(), setError("")
          }}
        >
          <MdCancel /> Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default RolesModal
